<template>
	<page>
		<module title="分销设置">
			<c-form ref="form">
				<c-form-item type="image" label="分销海报图" name="share_img_list" limit="5" required file-word="建议尺寸：600×1000像素，格式支持：jpg、png，最多上传5张"></c-form-item>
				<c-form-item label="各等级分销奖励">
					<ul class="tab flex">
						<li v-for="(item, i) in levelList" :key="i" :class="{'z-crt': currentTab == i}" @click="currentTab = i">{{item.level_name}}</li>
					</ul>
					<div v-for="(item, i) in levelList" :key="i" v-show="currentTab == i" class="tab-content">
						<c-form style="padding: 30px 24px;">
							<c-form title="推荐奖励设置" v-show="false">
								<c-form-item v-model="item.is_directly_reward" type="radio" label="直推奖励" :options="directOptions" word="代理会员直接推荐代理会员可获得『直推奖励』"></c-form-item>
								<c-form-item v-show="item.is_directly_reward == 2">
									<c-table v-model="item.directly_reward_list" border height="auto" style="width: 600px;">
										<c-table-column
											label="直推等级"
											name="recommend_level_name"
										></c-table-column>
										<c-table-column
											label="奖励金额 (元)"
										>
											<template v-slot="{data}">
												<c-input v-model="data.reward_money" word="元"></c-input>
											</template>
										</c-table-column>
									</c-table>
								</c-form-item>
								<c-form-item v-model="item.is_indirect_reward" type="radio" label="间推奖励" :options="indirectOptions" word="代理会员间接推荐代理会员可获得『间推奖励』"></c-form-item>
								<c-form-item v-show="item.is_indirect_reward == 2">
									<c-table v-model="item.indirect_reward_list" border height="auto" style="width: 600px;">
										<c-table-column
											label="间推等级"
											name="recommend_level_name"
										></c-table-column>
										<c-table-column
											label="奖励金额 (元)"
										>
											<template v-slot="{data}">
												<c-input v-model="data.reward_money" word="元"></c-input>
											</template>
										</c-table-column>
									</c-table>
								</c-form-item>
							</c-form>
							<c-form title="价差返佣设置">
								<c-form-item v-model="item.is_price_difference" type="radio" label="价差返佣" :options="commisionOptions" :inline-word="false" disabled>
									<div slot="word">
										<p>下级代理在商城下单，上级代理根据『等级折扣的差价』享受『全额价差返佣』。</p>
										<p>例：A是下级(购买商品单价为100元)，B是A的上级(购买商品单价为90元)，当A在商城下单后，如果B选择上级发货，B将获得10元价差；
                                            如果B选择云仓发货，则订单商品金额100元全部给B</p>
									</div>
								</c-form-item>
							</c-form>
						</c-form>
					</div>
				</c-form-item>
			</c-form>

			<template slot="button">
				<c-button size="m" @click="saveHandle()">提交保存</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	import validate from '@/assets/script/validate.js'
	
	export default {
		name: 'm_share',
		
		data() {
			return {
				levelList: [],
				currentTab: 0,
				
				directOptions: [{
					name: '开启',
					value: 2
				}, {
					name: '关闭',
					value: 1
				}],
				
				indirectOptions: [{
					name: '开启',
					value: 2
				}, {
					name: '关闭',
					value: 1
				}],
				
				commisionOptions: [{
					name: '开启',
					value: 2
				}, {
					name: '关闭',
					value: 1
				}]
			}
		},
		
		mounted() {
			this.request({
				url: '/share/config/detail',
				success: data => {
					this.$refs.form.set(data);
					this.levelList = data.level_list;
				}
			});
		},

		methods: {
			saveHandle() {
				this.$refs.form.submit({
					url: '/share/config/edit',
					rule: {
						share_img_list: '请上传分销海报图'
					},
					dataFormatter: data => {
						data.level_list = this.levelList;
						return data;
					},
					success: () => {
						this.$message({
							text: '保存成功'
						});
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.tab {
		margin-bottom: -1px;

		li {
			width: 100px;
			border: 1px solid #ddd;
			padding: 0 10px;
			margin-right: -1px;
			line-height: 40px;
			font-size: 13px;
			text-align: center;
			color: #000;
			background: #fff;
			cursor: pointer;

			&:hover {
				position: relative;
			theme-border(lesser);
			theme-color(lesser);
			}

			&.z-crt {
				position: relative;
			theme-border(lesser);
				color: #fff;
			theme-background(lesser);
			}
		}
		
		&-content {
			border: 1px solid #ddd;
		}
	}
</style>